export enum DataProvider {
  ADM = 1,
  Marex = 2,
  RJOBrien = 3,
  StoneX = 4,
  Cunningham = 5,
  Wedbush = 6,
  Lighthouse = 7,
  Dorman = 8,
}

export enum SynchronizationStatus {
  IDLE = 0,
  SUCCESS = 1,
  ERROR = 2,
  SHOULD_RETRY = 3,
}
